import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatRuDateTimeString } from '../../../../../helpers/date-time';
import { validateLang } from '../../../../../helpers/lang';
import { concatPath } from '../../../../../helpers/path';
import { validate } from '../../../../../helpers/validate';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { ManagerPath, PromotionPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { usePromotionStore } from '../../../../../store/use-promotion-store';

export const useCreatePromo = () => {
  const { postPromo, isLoading, promo, handleResetPromo, fetchPromo, putPromo, handleUpdatePromo } =
    usePromotionStore();
  const { t } = useLang();

  const params = useQueryParams().getQueryParams();
  const id = params.id;
  const prolong = params.prolong;

  useEffect(() => {
    if (id) fetchPromo(id);

    return () => handleResetPromo();
  }, [id]);

  useEffect(() => {
    if (prolong) {
      handleUpdatePromo({ active_from: undefined, active_to: undefined });
    }
  }, [promo?.id, prolong, fetchPromo]);

  const navigate = useNavigate();
  const isEdit = location.pathname.includes('edit') && !prolong;

  const handleNext = async () => {
    const frontActiveFrom = formatRuDateTimeString(promo?.active_from);
    const frontActiveTo = formatRuDateTimeString(promo?.active_to);

    const isValid = validate({
      name: { rule: () => validateLang(promo?.name) },
      img: { rule: () => !!promo?.image?.ru },
      branches: { rule: () => !!promo?.places?.length },
      'promo-from-date': { rule: () => !!frontActiveFrom?.split(' ')[0] },
      'promo-from-time': { rule: () => !!frontActiveFrom?.split(' ')[1] },
      'promo-to-date': { rule: () => !!frontActiveTo?.split(' ')[0] },
      'promo-to-time': { rule: () => !!frontActiveTo?.split(' ')[1] },
    });
    if (!isValid) return;

    try {
      if (isEdit && id) {
        await putPromo();
        window.history.back();
      } else {
        await postPromo();
        navigate(concatPath([RootPath.Manager, ManagerPath.Promotion, PromotionPath.List]));
      }
    } catch {
      console.error('error');
    }
  };

  return {
    handleNext,
    isLoading,
    id,
    t,
    isEdit,
    prolong,
  };
};
